// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ChartPieSliceIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M12.5 14.554a1 1 0 0 0 .5-.867v-9a1 1 0 0 0-1.333-.937 13.008 13.008 0 0 0-8.45 14.625 1 1 0 0 0 1.483.685l7.8-4.506ZM11 6.202v6.908l-5.985 3.454C5 16.375 5 16.185 5 16a11.015 11.015 0 0 1 6-9.797Zm16.292 3.363c-.01-.022-.022-.046-.036-.069-.014-.022-.025-.041-.039-.061A13.006 13.006 0 0 0 16 3a1 1 0 0 0-1 1v11.479l-9.851 5.737a1.001 1.001 0 0 0-.36 1.375A13 13 0 0 0 29 16a12.917 12.917 0 0 0-1.707-6.435ZM17 5.045a11.006 11.006 0 0 1 7.986 4.617L17 14.314V5.045ZM16 27a11.057 11.057 0 0 1-8.936-4.585l9.425-5.489.027-.017 9.471-5.516A11 11 0 0 1 16 27Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
